const Backbone = require('backbone');

module.exports = Backbone.Model.extend({
	api: 'local',
	url: function() {
		let url = `/app/api/rebates/${this.get('uniqueId')}`;
		if (this.get('zipCode')) {
			return `${url}/${this.get('zipCode')}`;
		} else {
			return url;
		}
	}
});
